/**
 * Numeric coercion for data cells — the single source of truth for "is this
 * cell a usable number?".
 *
 * `Number()` alone is unsafe for missing values: `Number(null)`, `Number('')`
 * and `Number('   ')` all return `0` (a finite number), so a guard like
 * `Number.isFinite(Number(cell))` silently treats blanks as legitimate zeros —
 * fabricating points, bins and filter matches at 0. `toFiniteNumber` excludes
 * null/undefined and blank strings explicitly before converting.
 */

export function toFiniteNumber(value: unknown): number | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}
